// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__1wFP2","nopad":"Button_nopad__1f-01","italic":"Button_italic__lEkad","wide":"Button_wide__1pBQd","outline":"Button_outline__2XxmF"};